module.exports = __webpack_public_path__ + "img/1696381769222-IMG_6667.png.699284fd.webp";